(() => {
  const init = (root) => {
    if (!root || root.dataset.pflBulkReady === 'true') return;
    root.dataset.pflBulkReady = 'true';
    const form = root.querySelector('[data-pfl-bulk-form]');
    if (!form) return;
    const directionInputs = [...form.querySelectorAll('[data-direction-mode]')];
    const consent = form.querySelector('[data-pfl-consent]');
    const notes = form.querySelector('[data-pfl-notes]');
    const status = form.querySelector('[data-form-status]');
    const submit = form.querySelector('[data-pfl-submit]');

    const setDirection = (mode) => {
      form.querySelectorAll('[data-direction-panel]').forEach((panel) => {
        const active = panel.dataset.directionPanel === mode;
        panel.hidden = !active;
        panel.querySelectorAll('input').forEach((input) => { input.disabled = !active; });
      });
      form.querySelector('[data-direction-error]')?.classList.remove('is-visible');
    };

    const validateInput = (input) => {
      if (input.disabled) return true;
      let valid = true;
      if (input.required) valid = input.value.trim().length > 0;
      if (valid && input.type === 'email') valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
      if (valid && input.type === 'url' && input.value.trim()) valid = /^https?:\/\/[^\s]+$/i.test(input.value.trim());
      input.setAttribute('aria-invalid', String(!valid));
      input.closest('.pfl-bulk-field')?.querySelector('.pfl-bulk-error')?.classList.toggle('is-visible', !valid);
      return valid;
    };

    const validate = () => {
      const fields = [...form.querySelectorAll('[data-pfl-validate]:not(:disabled)')];
      const results = fields.map(validateInput);
      const directionValid = directionInputs.some((input) => input.checked);
      form.querySelector('[data-direction-error]')?.classList.toggle('is-visible', !directionValid);
      results.push(directionValid);
      if (consent) {
        form.querySelector('[data-consent-error]')?.classList.toggle('is-visible', !consent.checked);
        results.push(consent.checked);
      }
      if (results.includes(false)) {
        const firstInvalid = fields.find((field) => field.getAttribute('aria-invalid') === 'true');
        if (firstInvalid) firstInvalid.focus();
        else if (!directionValid) directionInputs[0]?.focus();
        else consent?.focus();
      }
      return !results.includes(false);
    };

    directionInputs.forEach((input) => input.addEventListener('change', () => setDirection(input.dataset.directionMode)));
    form.querySelectorAll('[data-pfl-validate]').forEach((input) => {
      input.addEventListener('blur', () => validateInput(input));
      input.addEventListener('input', () => {
        if (input.getAttribute('aria-invalid') === 'true') validateInput(input);
      });
    });
    consent?.addEventListener('change', () => {
      if (consent.checked) form.querySelector('[data-consent-error]')?.classList.remove('is-visible');
    });
    notes?.addEventListener('input', () => {
      const counter = form.querySelector('[data-note-count]');
      if (counter) counter.textContent = String(notes.value.length);
    });
    form.querySelector('[data-pfl-file]')?.addEventListener('change', (event) => {
      const file = event.target.files?.[0];
      const label = form.querySelector('[data-file-name]');
      if (label) label.textContent = file?.name || label.dataset.defaultLabel || 'Choose file';
      if (file && file.size > 10 * 1024 * 1024) {
        event.target.value = '';
        if (label) label.textContent = 'File must be 10 MB or smaller';
      }
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const cooldownKey = `pfl-bulk-sent:${form.action}`;
      const lastSentAt = Number(sessionStorage.getItem(cooldownKey) || 0);
      if (Date.now() - lastSentAt < 30000) {
        status.textContent = 'Your request was already sent. Please wait a moment before sending again.';
        status.className = 'pfl-bulk-form-status is-error';
        status.hidden = false;
        return;
      }
      if (!validate()) return;
      status.hidden = true;
      submit.disabled = true;
      submit.textContent = submit.dataset.sendingLabel || 'Sending…';
      try {
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const payload = await response.json().catch(() => null);
        const accepted = payload && (payload.success === true || payload.success === 'true');
        const providerMessage = String(payload?.message || '');
        if (!response.ok || !accepted || /activat|confirm/i.test(providerMessage)) throw new Error('Delivery was not confirmed');
        sessionStorage.setItem(cooldownKey, String(Date.now()));
        form.reset();
        setDirection('');
        form.querySelector('[data-note-count]') && (form.querySelector('[data-note-count]').textContent = '0');
        status.textContent = form.dataset.successMessage;
        status.className = 'pfl-bulk-form-status is-success';
        status.hidden = false;
      } catch (error) {
        status.textContent = form.dataset.errorMessage;
        status.className = 'pfl-bulk-form-status is-error';
        status.hidden = false;
      } finally {
        submit.disabled = false;
        submit.innerHTML = `${submit.dataset.defaultLabel || 'Request a Team Quote'} <span aria-hidden="true">→</span>`;
      }
    });
    setDirection('');
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-pfl-bulk-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
